import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { QueryState } from "@/shared/ui/QueryState";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";


import { useNavigate, useParams } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";
import {
  useBranchWithSettingsQuery,
  useUpdateBranchSchedule,
} from "../api/queries";
import { BranchScheduleForm } from "../ui/BranchScheduleForm";

export function BranchSchedulePage() {
  const nav = useNavigate({ from: "/app/branches/$id/schedule" });
  const { id } = useParams({ from: "/app/branches/$id/schedule" });
  const { data, ...queryResult } = useBranchWithSettingsQuery(id);
  const updateSchedule = useUpdateBranchSchedule(id);

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            {
              label: "ສາຂາ",
              to: "/app/branches",
            },
            {
              label: "ເວລາເປີດ & ຕັ້ງຄ່າ Slot",
            },
          ]}
        />
      </Header>
      <Main>
        <div className="mb-6 flex flex-wrap items-center justify-between gap-2">
          <div>
            <h2 className="font-bold text-2xl tracking-tight">
              ເວລາເປີດ & ຕັ້ງຄ່າ Slot
            </h2>
            <p className="text-muted-foreground">
              ຈັດການເວລາເປີດ, ວິທີຮັບອໍເດີ ແລະ ຂີດຈຳກາດຕໍ່ slot ສຳລັບ{" "}
              {data?.name ?? "ສາຂາ"}
            </p>
          </div>
          <Button
            variant="outline"
            onClick={() => nav({ to: "/app/branches" })}
          >
            <ArrowLeftIcon className="size-4" />
            ກັບຄືນ
          </Button>
        </div>

        <QueryState
          result={queryResult}
          title="ກຳລັງໂຫຼດສາຂາ"
          description="ກຳລັງດຶງຕັ້ງຄ່າ"
          variant="fullscreen"
        >
          {data ? (
            <BranchScheduleForm
              branchId={id}
              data={data}
              onSubmit={async (payload) => {
                try {
                  await updateSchedule.mutateAsync(payload);
                  toast.success("ບັນທຶກຕັ້ງຄ່າສຳເລັດ", {
                    description: "ເວລາເປີດ ແລະ slot ຖືກອັບເດດແລ້ວ",
                  });
                  nav({ to: "/app/branches" });
                } catch {
                  // Error shown by fetcher/mutation
                }
              }}
              onDiscard={() => nav({ to: "/app/branches" })}
              submitting={updateSchedule.isPending}
            />
          ) : null}
        </QueryState>
      </Main>
    </>
  );
}
